import { useMutation, useQueryClient } from 'react-query'
import { QueryNames } from 'Hooks/api/queryNames'
import { toast } from 'react-toastify'
import { deleteRecurringAllowance } from 'Services/recurringAllowances'

export const useDeleteUserRecurringAllowanceMutation = () => {
  const queryClient = useQueryClient()

  return useMutation([QueryNames.DeleteUserRecurringAllowance], deleteRecurringAllowance, {
    onSuccess: (response) => {
      if (response.success) {
        // Invalidate all recurring allowances queries
        queryClient.invalidateQueries([QueryNames.GetUserRecurringAllowances])
        toast.success('Recurring allowance deleted successfully')
      } else {
        toast.error(`Failed to delete recurring allowance: ${response.message}`)
      }
    },
    onError: (error: any) => {
      console.error('Recurring allowance deletion error:', error)
      toast.error('Failed to delete recurring allowance')
    }
  })
}
